

export default {
  props: {
    bg: {
      default: 'white',
      type: String,
    },
    includeSubHeadings: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      headings: [],
      list: '',
      extendedList: [],
      toc: '',
      listLength:''
    }

  },
mounted() {
    const checkToc = document.querySelector("#toc").children;
    const tocExists = (checkToc.length > 0)
    console.log(checkToc)
    if(!tocExists) {
      this.getHeadings()
    }
  },
      methods: {
        showMore() {
          this.extendedList.forEach(item => {
            this.list.appendChild(item)
        })

        this.listLength = this.list.querySelectorAll('li').length
        this.toc.appendChild(this.list)
      },
      showLess () {
        const items = this.list.querySelectorAll('li')
        items.forEach((item,index) => {
          if(index > 4) {
            this.list.removeChild(this.list.children[index])
          }
        })
        this.listLength = this.list.querySelectorAll('li').length
        this.toc.appendChild(this.list)
      },
        getHeadings () {
          console.log('getting headings')
          let tags

          if(this.includeSubHeadings) {
            tags = ["h2", "h3"]
          } else {
            tags = ["h2"]
          }

          this.toc = document.querySelector("#toc");
          const scope = document.querySelector("body");
          this.list = document.createElement("ul");
          this.list.setAttribute("id", 'contents-list')
          let link
          let contentsItem
          const headings = Array.from(scope.querySelectorAll(tags.join(", ")));
          // list.classList.add("teflstyles");
          this.list.classList.add("grid-cols-1", "md:grid-cols-2");
          this.list.classList.add("contents");

          headings.forEach((heading, index) => {

            const level = Number(heading.nodeName[1]) - 1;
            console.log('level', level)

        // Skip adding downloads to contents

            if(level === 1) {

            if (heading.innerText.includes(`Download our`)) {
              return
            }
            // create ID for heading if it doesn't have one
            if (!heading.id) {
              heading.id = `${heading.innerText.toLowerCase().replaceAll(" ", "_")}`;
              heading.id=heading.id.replaceAll("/", "_")
            }

            contentsItem = document.createElement("li");
            contentsItem.classList.add(`toc`, `toc-item-l${level}`);

            // create link to point to ID of heading
            link = document.createElement("A")
            if(level === 1){
              link.classList.add("font-bold")
            }

            this.list.classList.add("toc", "toc-list")
            link.textContent = heading.innerText;
            link.href = `#${heading.id}`;

            // Add scrolling
            link.addEventListener('click', function (e) {
              e.preventDefault();
              document.querySelector(this.getAttribute('href')).scrollIntoView({
                  behavior: 'smooth'
              });
            })

              contentsItem.appendChild(link);

          // Append nested list to the contentsItem here

            // How to nest elements
            // if level === 1 and nextElement level === 2
            // loop through the headings from the next index on, if level is 2, do the stuff below and append to this heading
            // if level is 1, break the for loop
            let nextHeading

            // check it's not the end of the array
            if (index + 1 !== headings.length) {

              nextHeading = headings[index+1]
              console.log('nextHeading', nextHeading)

              // check next heading is an h3, other wise move on to next
              if (level === 1 && (Number(nextHeading.nodeName[1]) - 1) === 2) {
                console.log("...next heading l2, starting nested heading loop", nextHeading)
                const nextList = document.createElement("ul");
                nextList.classList.add("toc", "toc-nested-list")
                let nextContentsItem
                let nextLink
                // loop through remaining headings to next h3s
                for (let i = index+1; i < headings.length; i++) {

                  // break loop if next heading h2

                  if (level === 1 && (Number(headings[i].nodeName[1]) - 1) === 1) {
                    console.log("...next heading l1, breaking nested heading loop", heading)
                    break;
                  }
                  else {
                    nextContentsItem = document.createElement("li");
                    nextLink = document.createElement("A");
                    console.log('creating nested h3', headings[i])

                    // let nextLink
                    // let nextContentsItem
                    if (! headings[i].id) {
                      headings[i].id = `${ headings[i].innerText.toLowerCase().replaceAll(" ", "_")}`;
                      headings[i].id= headings[i].id.replaceAll("/", "_")
                    }


                    nextContentsItem.classList.add(`toc`, `toc-item-l2`);

                    // create link to point to ID of heading

                    nextLink.textContent =  headings[i].innerText;
                    nextLink.href = `#${headings[i].id}`;

                    // Add scrolling
                    nextLink.addEventListener('click', function (e) {
                      e.preventDefault();
                      document.querySelector(this.getAttribute('href')).scrollIntoView({
                          behavior: 'smooth'
                      });

                    })
                    nextContentsItem.appendChild(nextLink)

                    console.log('nextlist ',nextList)
                    nextList.appendChild(nextContentsItem)
                  }

                }

                // if(nextList.length > 0) {
                contentsItem.appendChild(nextList)
              // }
            }


            }
          }

          this.listLength = this.list.querySelectorAll("li").length
          console.log('list length: ', this.listLength)

          if (this.listLength < 5){
            this.list.appendChild(contentsItem);
          }
          else if (this.listLength >= 5) {
            this.extendedList.push(contentsItem)
          }

              console.log('list: ', this.list)
          })

          this.listLength = this.list.querySelectorAll("li").length

          // create title
          const title = document.createElement("H2");
          title.innerText = "Table of contents";


          this.toc.appendChild(title);
          this.toc.appendChild(this.list);
          console.log(this.toc)
          this.headings = headings;
        }
      },
          }


